import React from 'react'
import isEmpty from 'lodash/isEmpty'
import {
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
} from '@the-platform-group/component-library'
import { Button } from '@the-platform-group/component-library/Button'
import { Checkbox } from '@the-platform-group/component-library/Checkbox'
import { AsyncSelect } from '@the-platform-group/component-library/Select'

import useCustomerAccountManager from './hooks/useCustomerAccountManager'

const CustomerAccountManager = customer => {
  const {
    queryParams,
    accountManagers,
    loadUsers,
    disableUpdate,
    handleManagerChange,
    handleReceiveNotificationChange,
    handleSubmit,
    isUpsertingAccountManager,
  } = useCustomerAccountManager(customer)

  const { managers, receivesAssistantNotifications } = queryParams
  const disableUpdateButton = disableUpdate()

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="h6">Irwin Assistant Correspondence</Typography>
      </Grid>
      <FormGroup sx={{ width: '100%' }}>
        <Grid item container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <AsyncSelect
              isMulti
              id="userId"
              label="Account Manager"
              variant="outlined"
              onChange={handleManagerChange}
              optionsLoader={loadUsers}
              value={managers}
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={e => handleReceiveNotificationChange(e.target.checked)}
                  checked={receivesAssistantNotifications}
                />
              }
              label="Include in email"
            />
          </Grid>
          <Grid item>
            <Button
              onClick={handleSubmit}
              isLoading={isUpsertingAccountManager}
              disabled={disableUpdateButton}
            >
              {isEmpty(accountManagers) ? 'Add' : 'Update'}
            </Button>
          </Grid>
        </Grid>
      </FormGroup>
      {accountManagers.map(accountManager => {
        return (
          <Grid item xs={12} key={accountManager.id}>
            <Typography variant="caption" fontWeight="bold">
              Account Manager:{' '}
            </Typography>
            <Typography variant="caption">{`${accountManager.manager?.firstName} ${accountManager.manager?.lastName}`}</Typography>
            <Typography variant="caption"> | </Typography>
            <Typography variant="caption" fontWeight="bold">
              Notify in Email?{' '}
            </Typography>
            <Typography variant="caption">
              {accountManager.receivesAssistantNotifications?.toString()}
            </Typography>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default CustomerAccountManager
